"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addErrorRequestInterceptor = exports.addRequestSuccessInterceptor = void 0;
const localStorage_1 = require("@/utilities/localStorage");
function addRequestSuccessInterceptor() {
    return async (settings) => {
        const user = (0, localStorage_1.getItemFromLocalStorage)("AuthContext");
        if (user.accessToken) {
            const settingsWithToken = { ...settings };
            settingsWithToken.headers = {
                Authorization: `Bearer ${user.accessToken}`
            };
            return settingsWithToken;
        }
        return settings;
    };
}
exports.addRequestSuccessInterceptor = addRequestSuccessInterceptor;
function addErrorRequestInterceptor() {
    return (error) => {
        return Promise.reject(error);
    };
}
exports.addErrorRequestInterceptor = addErrorRequestInterceptor;
